import { ProcessesIndexRoute } from "@/routes/processes/processes-route";
import OmniRoute from "./[processId]/omni/omni-route";
import { omniRoutes } from "./[processId]/omni/omni-routes";
import HTZRoute from "@/routes/processes/[processId]/htz/htz-route";
import { htzRoutes } from "@/routes/processes/[processId]/htz/htz-routes";
import RLTRoute from "@/routes/processes/[processId]/rlt/rlt";
import { rltRoutes } from "@/routes/processes/[processId]/rlt/rlt-routes";
import VBSRoute from "@/routes/processes/[processId]/vbs/vbs";
import { vbsRoutes } from "@/routes/processes/[processId]/vbs/vbs-routes";
import WRHRoute from "./[processId]/wrh/wrh-route";
import { wrhRoutes } from "./[processId]/wrh/wrh-routes";

export const processesRoutes = [
  {
    index: true,
    element: <ProcessesIndexRoute />,
  },
  {
    path: "omni/:processId",
    element: <OmniRoute />,
    children: omniRoutes,
  },
  {
    path: "htz/:processId",
    element: <HTZRoute />,
    children: htzRoutes,
  },
  {
    path: "rlt/:processId",
    element: <RLTRoute />,
    children: rltRoutes,
  },
  {
    path: "vbs/:processId",
    element: <VBSRoute />,
    children: vbsRoutes,
  },
  {
    path: "wrh/:processId",
    element: <WRHRoute />,
    children: wrhRoutes,
  },
];
